export const ADITIVO = 'ADITIVO';
export const ADITIVO_START = 'ADITIVO_START';
export const ADITIVO_SUCCESS = 'ADITIVO_SUCCESS';
export const ADITIVO_ERROR = 'ADITIVO_ERROR';

export const ADITIVO_ARQUIVOS = 'ADITIVO_ARQUIVOS';
export const ADITIVO_ARQUIVOS_START = 'ADITIVO_ARQUIVOS_START';
export const ADITIVO_ARQUIVOS_SUCCESS = 'ADITIVO_ARQUIVOS_SUCCESS';
export const ADITIVO_ARQUIVOS_ERROR = 'ADITIVO_ARQUIVOS_ERROR';
